import React, { useState } from 'react'
import { SurveyError } from 'survey-react'
import download from 'downloadjs'

const FileUploadWrapper = ({ question }) => {
  const [fileName, _setFileName] = useState(question.value ? question.value.name : null)
  const [filePath, _] = useState(question.value ? question.value.file_path : null)
  const [fileDate] = useState(question.value ? question.value.created_date : null)
  const maximumFileSize = 10

  const goodFileSize = (fileSize, filename) => {
    const sizeMb = fileSize / 1024 / 1024

    if (sizeMb > maximumFileSize) {
      question.addError(
        new SurveyError(
          `The file ${filename} is too big. Maximum filesize per attachment is ${maximumFileSize}MB`
        )
      )
      return false
    }

    return true
  }

  const handleFileUpload = event => {
    question.clear()
    const file = event.target.files[0]

    if (file) {
      if (!goodFileSize(file.size, file.name)) {
        return false
      }

      const reader = new FileReader()
      reader.onload = readerEvt => {
        const binaryString = btoa(readerEvt.target.result)
        const blob = {
          name: file.name,
          type: file.type,
          content: `data:${file.type};base64,${binaryString}`
        }
        question.value = blob
        return blob
      }
      reader.readAsBinaryString(file)
    }
  }

  const onDownloadClickHandler = event => {
    event.preventDefault()
    download(question.value.content, question.value.name, question.value.type)
  }

  return (
    <>
      {question.isReadOnly ? (
        <input disabled value={fileName} />
      ) : (
        <input type="file" onChange={handleFileUpload} accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx" />
      )}

      {question.value && question.value.content && (
        <a href={question.value.name} onClick={onDownloadClickHandler}>
          You selected the following file: {question.value.name}
        </a>
      )}

      {filePath && (
        <a href={filePath} target="_blank" rel="noreferrer">
          Download the file uploaded on {fileDate}
        </a>
      )}
    </>
  )
}

export default FileUploadWrapper
